import { ActionReducerMap } from '@ngrx/store';
import { AppState } from './app.states';
import { commonReducer } from './common/common.reducer'
import { memberJoinReducer } from '../views/member-join/reducer'
import { superannuationProviderSearchReducer } from '../components/superannuation-provider-search/reducer'
import { initialDataReducer } from '../views/member-join/steps/nmj-initial-data/reducer';
import { detailsReducer } from '../views/member-join/steps/nmj-details/reducer';
import { mobileVerificationReducer } from '../views/member-join/steps/nmj-mobile-verification/reducer';
import { termsConditionsReducer } from '../views/member-join/steps/nmj-terms-conditions/reducer';
import { tfnReducer } from '../views/member-join/steps/nmj-tfn/reducer';
import { rollinReducer } from '../views/member-join/steps/nmj-rollin/reducer';
import { investmentsReducer } from '../views/member-join/steps/nmj-investments/reducer';
import { reviewReducer } from '../views/member-join/steps/nmj-review/reducer';

export const reducers: ActionReducerMap<AppState> = {
  memberJoinState: memberJoinReducer,
  commonState: commonReducer,
  superannuationProviderSearchState: superannuationProviderSearchReducer,
  initialDataState: initialDataReducer,
  detailsState: detailsReducer,
  mobileVerificationState: mobileVerificationReducer,
  termsConditionsState: termsConditionsReducer,
  tfnState: tfnReducer,
  rollinState: rollinReducer,
  investmentsState: investmentsReducer,
  reviewState: reviewReducer
};
